export const FormLabel = {
  baseStyle: {
    color: "darkBrand",
  },
};

export const FormHelperText = {
  baseStyle: {
    fontSize: "sm",
    marginTop: "0",
    marginBottom: "6",
  },
};

export const Textarea = {
  baseStyle: {
    maxWidth: "2xl",
  },
  sizes: {
    sm: {
      rounded: "base",
    },
  },
  defaultProps: {
    rows: 3,
    size: "sm",
    focusBorderColor: "gray.600",
    errorBorderColor: "invalid.500",
  },
};

export const Input = {
  sizes: {
    lg: {
      field: {
        fontSize: "medium",
      },
    },
  },
  defaultProps: {
    rows: 3,
    size: "sm",
    color: "secondary",
    focusBorderColor: "gray.600",
    errorBorderColor: "invalid.500",
  },
};

export const NumberInput = {
  defaultProps: {
    focusBorderColor: "gray.600",
    errorBorderColor: "invalid",
  },
};

export const Radio = {
  defaultProps: {
    colorScheme: "primary",
    size: "lg",
  },
};

export const Checkbox = {
  defaultProps: {
    colorScheme: "primary",
    size: "lg",
  },
};

export const FormErrorMessage = {
  baseStyle: {
    text: {
      color: "invalid.500",
    },
  },
};
